import AddIcon from '@mui/icons-material/Add';
import { useIsMobile } from '@core/hooks/useIsMobile';
import ActionButton from './ActionButton';

export interface PageAddConfig {
  label: string;
  onAdd: () => void;
}

type PageAddProps = PageAddConfig & {
  size?: 'sm' | 'md';
};

const PageAdd: React.FC<PageAddProps> = ({ label, onAdd, size = 'md' }) => {
  const isMobile = useIsMobile();

  return (
    <ActionButton
      variant="primary"
      size={size}
      onClick={onAdd}
      icon={<AddIcon />}
      aria-label={label}
    >
      {!isMobile && label}
    </ActionButton>
  );
};

export default PageAdd;
